import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, DefaultValueAccessor, FormGroup, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';

export const TEXT_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HappySelectInputComponent),
    multi: true,
};

@Component({
  selector: 'happy-select-input',
  templateUrl: './happy-select-input.component.html',
  styleUrls: ['./happy-select-input.component.css', '../styles.css'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
  providers: [TEXT_INPUT_VALUE_ACCESSOR]
})
export class HappySelectInputComponent implements ControlValueAccessor {

  @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;

  @Input() formControlName: string;
  @Input() required = true;
  @Input() placeholder: string;
  form: FormGroup;

  constructor(private parentForm: FormGroupDirective) {
  }

  ngOnInit() {
      this.form = this.parentForm.form;
  }

  get hasError() {
      const {form, formControlName} = this
      const control = form.controls[formControlName];
      return control.errors && control.touched && control.dirty;
  }

  writeValue(obj: any) {
      this.valueAccessor.writeValue(obj);
  }

  registerOnChange(fn: any) {
      this.valueAccessor.registerOnChange(fn);
  }

  registerOnTouched(fn: any) {
      this.valueAccessor.registerOnTouched(fn);
  }

  setDisabledState(isDisabled: boolean) {
      this.valueAccessor.setDisabledState(isDisabled);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-select-input/happy-select-input.component.ts